import { MdAddChart, MdCompareArrows, MdLogin } from "react-icons/md";

// Page Title: WordPress as IDP
export const wpidpData = [
    {
        title: "Tableau SSO using WordPress to view Embedded charts",
        video: true,
        videoId: "R40as235Vxk?si=Pqahp6uhzXlS-ihj",
        videoType: "youtube",
        icon: <MdAddChart className='text-white fs-5' />
    },
    {
        title: "SSO into Freshdesk using WordPress",
        video: true,
        videoId: "U1QRUmBO1UE?si=3wmUowHp5SvX_MX5",
        videoType: "youtube",
        icon: <MdLogin className='text-white fs-5' />
    },
    {
        title: "SSO between two WordPress sites",
        video: true,
        videoId: "p9W4bnRgHUQ?si=UeF8FUx6oqqaPIAK",
        videoType: "youtube",
        icon: <MdCompareArrows className='text-white fs-5' />
    }
]